import { FC, useEffect, useLayoutEffect } from 'react';

import Helmet from '@/components/meta/Helmet';
import GuideWalletTemplate from '@/components/templates/Guide/Wallet';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';

import { GuidePageTitles } from '../types';

const GuideWalletPage: FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useEffect(() => {
    setBreadcrumbs([
      {
        name: 'ご利用ガイド',
        to: '/guide',
      },
      {
        name: '入金/払戻金 残高とは？',
        to: '',
      },
    ]);
  }, []);

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  return (
    <>
      <Helmet
        meta={{
          title: GuidePageTitles.Wallet,
          description:
            'DMM競輪のご利用ガイドページ。DMM競輪で投票ができる預かり金「入金/払戻金残高」についてご案内します。',
          keywords: `${GuidePageTitles.Wallet},ご利用ガイド,%s`,
        }}
      />
      <GuideWalletTemplate />
    </>
  );
};

export default GuideWalletPage;
